export default "__VITE_PUBLIC_ASSET__5bf58822__"